import React from 'react';
import Icon from '../../components/AppIcon';
import { Link } from 'react-router-dom';
import TopNavigation from '../../components/TopNavigation';
import Footer from '../../components/Footer';

const AutomotiveFleetManagementUseCaseDetail = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <TopNavigation />
      
      {/* Hero Section */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      
      {/* Left Column - Text Content */}
      <div>
        <div 
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-xs font-semibold uppercase tracking-wider mb-6 w-fit"
          style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)', border: '1px solid rgba(245, 203, 92, 0.4)', color: '#F5CB5C' }}
        >
          Automotive Fleet Management
        </div>
        
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight" style={{ color: '#E8EDDF' }}>
          Fleet Management Without Physical Presence
        </h1>
        
        <p className="text-base md:text-lg leading-relaxed mb-8" style={{ color: '#9CA3AF' }}>
          Sleeve virtualizes the engineer's presence inside test vehicles—enabling remote configuration, edge-to-cloud data flow, and real-time access to in-vehicle devices with measurable ROI.
        </p>
        
        <Link 
          to="/contact" 
          className="inline-flex items-center gap-2 px-8 py-4 rounded-lg font-semibold text-base transition-colors"
          style={{ backgroundColor: '#4FB3B8', color: '#242423' }}
        >
          Request a Cost Analysis
        </Link>
      </div>
      
      {/* Right Column - Diagram */}
      <div className="flex items-center justify-center">
        <div 
          className="w-full rounded-xl p-6"
          style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
        >
          <svg width="100%" height="420" viewBox="0 0 420 420" className="max-w-full">
            
            {/* Cloud Control Plane Box */}
            <rect x="30" y="20" width="360" height="70" rx="6" fill="#242423" stroke="#F5CB5C" strokeWidth="1.5" />
            <circle cx="370" cy="35" r="4" fill="#F5CB5C" opacity="0.5" />
            
            {/* Cloud Icon */}
            <g transform="translate(50, 40)">
              <path d="M4 12a4 4 0 014-4 6 6 0 0111.2-2A5 5 0 1120 14H8a4 4 0 01-4-2z" fill="none" stroke="#F5CB5C" strokeWidth="1.5" />
            </g>
            
            <text x="85" y="50" fill="#F5CB5C" fontSize="12" fontWeight="700">CLOUD CONTROL PLANE</text>
            <text x="50" y="72" fill="#9CA3AF" fontSize="9">Fleet Management • Monitoring • Analytics</text>
            
            {/* Dashed lines from cloud to vehicles */}
            <line x1="120" y1="90" x2="120" y2="140" stroke="#9CA3AF" strokeWidth="1" strokeDasharray="4 3" />
            <line x1="210" y1="90" x2="210" y2="140" stroke="#9CA3AF" strokeWidth="1" strokeDasharray="4 3" />
            <line x1="300" y1="90" x2="300" y2="140" stroke="#9CA3AF" strokeWidth="1" strokeDasharray="4 3" />
            
            {/* Arrow heads */}
            <polygon points="120,140 116,132 124,132" fill="#9CA3AF" />
            <polygon points="210,140 206,132 214,132" fill="#9CA3AF" />
            <polygon points="300,140 296,132 304,132" fill="#9CA3AF" />
            
            {/* Vehicle 1 */}
            <g>
              <rect x="30" y="145" width="130" height="95" rx="6" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
              {/* Number badge */}
              <circle cx="145" cy="145" r="12" fill="#4FB3B8" />
              <text x="145" y="149" textAnchor="middle" fill="#242423" fontSize="10" fontWeight="700">1</text>
              
              {/* Header icons */}
              <g transform="translate(40, 155)">
                <path d="M0 4h8M12 4h8" stroke="#F5CB5C" strokeWidth="1.5" fill="none" />
              </g>
              <g transform="translate(100, 155)">
                <rect x="0" y="0" width="12" height="8" rx="1" fill="none" stroke="#F5CB5C" strokeWidth="1" />
                <line x1="3" y1="4" x2="5" y2="4" stroke="#F5CB5C" strokeWidth="1" />
                <line x1="7" y1="4" x2="9" y2="4" stroke="#F5CB5C" strokeWidth="1" />
              </g>
              
              <text x="45" y="182" fill="#F5CB5C" fontSize="11" fontWeight="600">VEHICLE 1</text>
              
              {/* Location */}
              <circle cx="45" cy="198" r="4" fill="none" stroke="#9CA3AF" strokeWidth="1" />
              <circle cx="45" cy="198" r="1.5" fill="#9CA3AF" />
              <text x="55" y="201" fill="#9CA3AF" fontSize="9">Munich</text>
              
              {/* Edge Node */}
              <rect x="40" y="210" width="110" height="22" rx="4" fill="transparent" stroke="#3A3A38" strokeWidth="1" />
              <circle cx="55" cy="221" r="5" fill="none" stroke="#9CA3AF" strokeWidth="1" />
              <text x="65" y="224" fill="#9CA3AF" fontSize="8">Edge Node</text>
            </g>
            
            {/* Vehicle 2 */}
            <g>
              <rect x="175" y="145" width="130" height="95" rx="6" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
              {/* Number badge */}
              <circle cx="290" cy="145" r="12" fill="#F5CB5C" />
              <text x="290" y="149" textAnchor="middle" fill="#242423" fontSize="10" fontWeight="700">2</text>
              
              {/* Header icons */}
              <g transform="translate(185, 155)">
                <path d="M0 4h8M12 4h8" stroke="#F5CB5C" strokeWidth="1.5" fill="none" />
              </g>
              <g transform="translate(245, 155)">
                <rect x="0" y="0" width="12" height="8" rx="1" fill="none" stroke="#F5CB5C" strokeWidth="1" />
                <line x1="3" y1="4" x2="5" y2="4" stroke="#F5CB5C" strokeWidth="1" />
                <line x1="7" y1="4" x2="9" y2="4" stroke="#F5CB5C" strokeWidth="1" />
              </g>
              
              <text x="190" y="182" fill="#F5CB5C" fontSize="11" fontWeight="600">VEHICLE 2</text>
              
              {/* Location */}
              <circle cx="190" cy="198" r="4" fill="none" stroke="#9CA3AF" strokeWidth="1" />
              <circle cx="190" cy="198" r="1.5" fill="#9CA3AF" />
              <text x="200" y="201" fill="#9CA3AF" fontSize="9">Stuttgart</text>
              
              {/* Edge Node */}
              <rect x="185" y="210" width="110" height="22" rx="4" fill="transparent" stroke="#3A3A38" strokeWidth="1" />
              <circle cx="200" cy="221" r="5" fill="none" stroke="#9CA3AF" strokeWidth="1" />
              <text x="210" y="224" fill="#9CA3AF" fontSize="8">Edge Node</text>
            </g>
            
            {/* Vehicle 3 */}
            <g>
              <rect x="320" y="145" width="90" height="95" rx="6" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
              {/* Number badge */}
              <circle cx="395" cy="145" r="12" fill="#9CA3AF" />
              <text x="395" y="149" textAnchor="middle" fill="#242423" fontSize="10" fontWeight="700">3</text>
              
              {/* Header icons */}
              <g transform="translate(330, 155)">
                <path d="M0 4h8M12 4h8" stroke="#F5CB5C" strokeWidth="1.5" fill="none" />
              </g>
              <g transform="translate(370, 155)">
                <rect x="0" y="0" width="12" height="8" rx="1" fill="none" stroke="#F5CB5C" strokeWidth="1" />
              </g>
              
              <text x="330" y="182" fill="#F5CB5C" fontSize="11" fontWeight="600">VEHICLE 3</text>
              
              {/* Location */}
              <circle cx="330" cy="198" r="4" fill="none" stroke="#9CA3AF" strokeWidth="1" />
              <circle cx="330" cy="198" r="1.5" fill="#9CA3AF" />
              <text x="340" y="201" fill="#9CA3AF" fontSize="9">Berlin</text>
              
              {/* Edge Node */}
              <rect x="325" y="210" width="80" height="22" rx="4" fill="transparent" stroke="#3A3A38" strokeWidth="1" />
              <circle cx="340" cy="221" r="5" fill="none" stroke="#9CA3AF" strokeWidth="1" />
              <text x="350" y="224" fill="#9CA3AF" fontSize="8">Edge Node</text>
            </g>
            
            {/* Arrows from vehicles to Edge-to-Cloud */}
            <line x1="95" y1="240" x2="95" y2="280" stroke="#F5CB5C" strokeWidth="1.5" />
            <polygon points="95,275 91,265 99,265" fill="#F5CB5C" />
            
            <line x1="240" y1="240" x2="240" y2="280" stroke="#F5CB5C" strokeWidth="1.5" />
            <polygon points="240,275 236,265 244,265" fill="#F5CB5C" />
            
            <line x1="365" y1="240" x2="365" y2="280" stroke="#F5CB5C" strokeWidth="1.5" />
            <polygon points="365,275 361,265 369,265" fill="#F5CB5C" />
            
            {/* Edge-to-Cloud Data Flow Box */}
            <rect x="30" y="285" width="360" height="45" rx="6" fill="#242423" stroke="#F5CB5C" strokeWidth="1.5" />
            
            {/* Server icon */}
            <g transform="translate(150, 298)">
              <rect x="0" y="0" width="16" height="6" rx="1" fill="none" stroke="#F5CB5C" strokeWidth="1" />
              <rect x="0" y="8" width="16" height="6" rx="1" fill="none" stroke="#F5CB5C" strokeWidth="1" />
            </g>
            
            <text x="175" y="312" fill="#F5CB5C" fontSize="11" fontWeight="600">EDGE-TO-CLOUD DATA FLOW</text>
            
            {/* Remote Engineer */}
            <g transform="translate(165, 350)">
              {/* Dashed circle */}
              <circle cx="45" cy="30" r="25" fill="none" stroke="#F5CB5C" strokeWidth="1.5" strokeDasharray="4 3" />
              
              {/* User icon */}
              <circle cx="45" cy="24" r="8" fill="none" stroke="#F5CB5C" strokeWidth="1.5" />
              <path d="M30 45c0-8 7-12 15-12s15 4 15 12" fill="none" stroke="#F5CB5C" strokeWidth="1.5" />
              
              {/* Label */}
              <text x="80" y="34" fill="#4FB3B8" fontSize="11" fontWeight="500">Remote Engineer</text>
            </g>
            
          </svg>
        </div>
      </div>
      
    </div>
  </div>
</section>


      {/* The Cost of Decentralized Fleet Management */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        The Cost of Decentralized Fleet Management
      </h2>
      <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#9CA3AF' }}>
        Manual fleet operations create measurable operational expense and development delays.
      </p>
    </div>
    
    {/* Three Cards */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      
      {/* High OPEX */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        {/* Icon */}
        <div 
          className="w-12 h-12 rounded-xl flex items-center justify-center mb-6"
          style={{ backgroundColor: 'rgba(255, 107, 107, 0.15)', border: '1px solid rgba(255, 107, 107, 0.3)' }}
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
            <line x1="12" y1="1" x2="12" y2="23" />
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
          </svg>
        </div>
        
        <h3 className="text-xl md:text-2xl font-bold mb-5" style={{ color: '#E8EDDF' }}>
          High OPEX
        </h3>
        
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Engineers travel to vehicle locations</span>
          </li>
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Manual configuration and data retrieval</span>
          </li>
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Per-diem, logistics costs, and delays</span>
          </li>
        </ul>
      </div>
      
      {/* Critical Delays */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        {/* Icon */}
        <div 
          className="w-12 h-12 rounded-xl flex items-center justify-center mb-6"
          style={{ backgroundColor: 'rgba(255, 107, 107, 0.15)', border: '1px solid rgba(255, 107, 107, 0.3)' }}
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>
        
        <h3 className="text-xl md:text-2xl font-bold mb-5" style={{ color: '#E8EDDF' }}>
          Critical Delays
        </h3>
        
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Manual workflows don't scale with fleet size</span>
          </li>
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Multi-vendor tooling fragmentation</span>
          </li>
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Slower development and validation cycles</span>
          </li>
        </ul>
      </div>
      
      {/* Unreliable Access */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        {/* Icon */}
        <div 
          className="w-12 h-12 rounded-xl flex items-center justify-center mb-6"
          style={{ backgroundColor: 'rgba(255, 107, 107, 0.15)', border: '1px solid rgba(255, 107, 107, 0.3)' }}
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
          </svg>
        </div>
        
        <h3 className="text-xl md:text-2xl font-bold mb-5" style={{ color: '#E8EDDF' }}>
          Unreliable Access
        </h3>
        
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Vehicles relocated between test sites</span>
          </li>
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Shipping equipment to remote locations</span>
          </li>
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Poor utilization of fleet assets</span>
          </li>
        </ul>
      </div>
      
    </div>
    
  </div>
</section>

      {/* Sleeve: Seamless Fleet Access */}
 <section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        Sleeve: Seamless Fleet Access
      </h2>
      <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#9CA3AF' }}>
        A single platform for managing test fleets as if engineers were physically in-car.
      </p>
    </div>
    
    {/* 3x2 Grid of Cards */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      
      {/* Secure Device Sharing */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-start gap-4 mb-4">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(79, 179, 184, 0.1)', border: '1px solid rgba(79, 179, 184, 0.2)' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold pt-2" style={{ color: '#E8EDDF' }}>
            Secure Device Sharing
          </h3>
        </div>
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Virtual and physical in-vehicle devices accessible remotely with role-based access control and audit logging.
        </p>
      </div>
      
      {/* Remote Configuration */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-start gap-4 mb-4">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(245, 203, 92, 0.1)', border: '1px solid rgba(245, 203, 92, 0.2)' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <rect x="3" y="3" width="18" height="6" rx="1" />
              <rect x="3" y="12" width="18" height="6" rx="1" />
              <circle cx="7" cy="6" r="1" fill="#F5CB5C" />
              <circle cx="7" cy="15" r="1" fill="#F5CB5C" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold pt-2" style={{ color: '#E8EDDF' }}>
            Remote Configuration
          </h3>
        </div>
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Configure data loggers, ECU parameters, and diagnostic tools remotely without physical vehicle access.
        </p>
      </div>
      
      {/* Fleet Monitoring */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-start gap-4 mb-4">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(79, 179, 184, 0.1)', border: '1px solid rgba(79, 179, 184, 0.2)' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
              <polyline points="17 6 23 6 23 12" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold pt-2" style={{ color: '#E8EDDF' }}>
            Fleet Monitoring
          </h3>
        </div>
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Real-time dashboards showing fleet status, vehicle locations, active sessions, and system health across all sites.
        </p>
      </div>
      
      {/* Remote Logging Control */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-start gap-4 mb-4">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(156, 163, 175, 0.1)', border: '1px solid rgba(156, 163, 175, 0.2)' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold pt-2" style={{ color: '#E8EDDF' }}>
            Remote Logging Control
          </h3>
        </div>
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Start, stop, and retrieve logs from test vehicles remotely. Automated upload to cloud storage for analysis.
        </p>
      </div>
      
      {/* Cross-Location Debugging */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-start gap-4 mb-4">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(245, 203, 92, 0.1)', border: '1px solid rgba(245, 203, 92, 0.2)' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold pt-2" style={{ color: '#E8EDDF' }}>
            Cross-Location Debugging
          </h3>
        </div>
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Debug issues on vehicles located anywhere in the fleet. Consistent tooling across all test sites and garages.
        </p>
      </div>
      
      {/* Full Fleet Utilization */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-start gap-4 mb-4">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(245, 203, 92, 0.1)', border: '1px solid rgba(245, 203, 92, 0.2)' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 0 0-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold pt-2" style={{ color: '#E8EDDF' }}>
            Full Fleet Utilization
          </h3>
        </div>
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Maximize vehicle utilization by enabling remote access. No idle vehicles waiting for on-site engineers.
        </p>
      </div>
      
    </div>
    
  </div>
</section>

      {/* ROI Achieved Within the Year */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        ROI Achieved Within the Year
      </h2>
      <p className="text-base md:text-lg" style={{ color: '#9CA3AF' }}>
        Conservative estimates for a fleet of 20 test vehicles across 3 locations.
      </p>
    </div>
    
    {/* Table Card */}
    <div 
      className="rounded-xl p-6 md:p-8 mb-8"
      style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
    >
      <h3 className="text-xl md:text-2xl font-bold mb-6" style={{ color: '#4FB3B8' }}>
        Annual Cost Savings Analysis
      </h3>
      
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr style={{ borderBottom: '1px solid #3A3A38' }}>
              <th className="text-left py-4 pr-4 text-sm font-medium" style={{ color: '#9CA3AF' }}>Manual Task Eliminated</th>
              <th className="text-center py-4 px-4 text-sm font-medium" style={{ color: '#9CA3AF' }}>Frequency</th>
              <th className="text-center py-4 px-4 text-sm font-medium" style={{ color: '#9CA3AF' }}>Time Saved</th>
              <th className="text-right py-4 pl-4 text-sm font-medium" style={{ color: '#9CA3AF' }}>Annual Cost Without Sleeve</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ borderBottom: '1px solid #3A3A38' }}>
              <td className="py-4 pr-4">
                <div className="text-sm font-medium" style={{ color: '#E8EDDF' }}>On-site vehicle access for configuration</div>
                <div className="text-xs mt-1" style={{ color: '#9CA3AF' }}>Travel time + on-site work</div>
              </td>
              <td className="py-4 px-4 text-sm text-center" style={{ color: '#9CA3AF' }}>3x per week</td>
              <td className="py-4 px-4 text-sm font-medium text-center" style={{ color: '#4FB3B8' }}>4 hours</td>
              <td className="py-4 pl-4 text-sm text-right" style={{ color: '#E8EDDF' }}>€124,800</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #3A3A38' }}>
              <td className="py-4 pr-4">
                <div className="text-sm font-medium" style={{ color: '#E8EDDF' }}>Manual log retrieval from vehicles</div>
                <div className="text-xs mt-1" style={{ color: '#9CA3AF' }}>Physical data download + transfer</div>
              </td>
              <td className="py-4 px-4 text-sm text-center" style={{ color: '#9CA3AF' }}>5x per week</td>
              <td className="py-4 px-4 text-sm font-medium text-center" style={{ color: '#4FB3B8' }}>2 hours</td>
              <td className="py-4 pl-4 text-sm text-right" style={{ color: '#E8EDDF' }}>€52,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #3A3A38' }}>
              <td className="py-4 pr-4">
                <div className="text-sm font-medium" style={{ color: '#E8EDDF' }}>Cross-location vehicle debugging</div>
                <div className="text-xs mt-1" style={{ color: '#9CA3AF' }}>Engineer travel between test sites</div>
              </td>
              <td className="py-4 px-4 text-sm text-center" style={{ color: '#9CA3AF' }}>2x per week</td>
              <td className="py-4 px-4 text-sm font-medium text-center" style={{ color: '#4FB3B8' }}>6 hours</td>
              <td className="py-4 pl-4 text-sm text-right" style={{ color: '#E8EDDF' }}>€62,400</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #3A3A38' }}>
              <td className="py-4 pr-4">
                <div className="text-sm font-medium" style={{ color: '#E8EDDF' }}>Shipping equipment to remote sites</div>
                <div className="text-xs mt-1" style={{ color: '#9CA3AF' }}>Logistics + waiting time</div>
              </td>
              <td className="py-4 px-4 text-sm text-center" style={{ color: '#9CA3AF' }}>1x per week</td>
              <td className="py-4 px-4 text-sm font-medium text-center" style={{ color: '#4FB3B8' }}>8 hours</td>
              <td className="py-4 pl-4 text-sm text-right" style={{ color: '#E8EDDF' }}>€20,800</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #3A3A38' }}>
              <td className="py-4 pr-4">
                <div className="text-sm font-medium" style={{ color: '#E8EDDF' }}>Vehicle coordination overhead</div>
                <div className="text-xs mt-1" style={{ color: '#9CA3AF' }}>Scheduling + availability checks</div>
              </td>
              <td className="py-4 px-4 text-sm text-center" style={{ color: '#9CA3AF' }}>Daily</td>
              <td className="py-4 px-4 text-sm font-medium text-center" style={{ color: '#4FB3B8' }}>1 hour</td>
              <td className="py-4 pl-4 text-sm text-right" style={{ color: '#E8EDDF' }}>€26,000</td>
            </tr>
            {/* Total Row */}
            <tr>
              <td className="py-5 pr-4">
                <div className="text-base font-semibold" style={{ color: '#E8EDDF' }}>Total Annual Savings</div>
              </td>
              <td className="py-5 px-4"></td>
              <td className="py-5 px-4 text-center">
                <div className="text-xl font-bold" style={{ color: '#4FB3B8' }}>840+ hours</div>
                <div className="text-xs" style={{ color: '#9CA3AF' }}>Per engineer</div>
              </td>
              <td className="py-5 pl-4 text-right">
                <div className="text-xl font-bold" style={{ color: '#4FB3B8' }}>€292,000+</div>
                <div className="text-xs" style={{ color: '#9CA3AF' }}>Conservative estimate</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
    {/* Three Stat Cards */}
    <div 
      className="rounded-xl p-6 md:p-8 mb-8"
      style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        
        {/* 3-5x */}
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
              <polyline points="17 6 23 6 23 12" />
            </svg>
          </div>
          <div className="text-3xl md:text-4xl font-bold mb-2" style={{ color: '#E8EDDF' }}>3-5x</div>
          <p className="text-sm" style={{ color: '#9CA3AF' }}>
            Faster iteration cycles with instant remote access
          </p>
        </div>
        
        {/* 85% */}
        <div className="text-center" style={{ borderLeft: '1px solid #3A3A38', borderRight: '1px solid #3A3A38' }}>
          <div className="flex justify-center mb-4">
            <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          </div>
          <div className="text-3xl md:text-4xl font-bold mb-2" style={{ color: '#E8EDDF' }}>85%</div>
          <p className="text-sm" style={{ color: '#9CA3AF' }}>
            Reduction in engineer travel to vehicle locations
          </p>
        </div>
        
        {/* 100% */}
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M5 17h14M6 9h12l-1-4H7L6 9zM6 9v8h12V9" />
              <circle cx="8" cy="17" r="2" />
              <circle cx="16" cy="17" r="2" />
            </svg>
          </div>
          <div className="text-3xl md:text-4xl font-bold mb-2" style={{ color: '#E8EDDF' }}>100%</div>
          <p className="text-sm" style={{ color: '#9CA3AF' }}>
            Fleet utilization with remote access capability
          </p>
        </div>
        
      </div>
    </div>
    
    {/* Assumptions Footer */}
    <div className="text-center">
      <p className="text-xs" style={{ color: '#9CA3AF' }}>
        <span className="font-semibold" style={{ color: '#E8EDDF' }}>Assumptions:</span> 20 test vehicles across 3 locations, €100/hour loaded engineer cost, 52 working weeks per year. Actual savings vary based on fleet size, geographic distribution, and operational patterns.
      </p>
    </div>
    
  </div>
</section>
      {/* Edge-to-Cloud Architecture */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        Edge-to-Cloud Architecture
      </h2>
      <p className="text-base md:text-lg" style={{ color: '#9CA3AF' }}>
        Two core software components enable seamless fleet management.
      </p>
    </div>
    
    {/* Two Cards */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
      
      {/* Edge Component - Sleeve Dock */}
      <div 
        className="rounded-xl p-6 md:p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div 
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-xs font-semibold uppercase tracking-wider mb-4"
          style={{ backgroundColor: 'transparent', border: '1px solid #F5CB5C', color: '#F5CB5C' }}
        >
          Edge Component
        </div>
        
        <h3 className="text-2xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
          Sleeve Dock
        </h3>
        
        <p className="text-sm leading-relaxed mb-6" style={{ color: '#9CA3AF' }}>
          Lightweight software installed in the vehicle. Orchestrates connections to in-car devices and manages edge applications.
        </p>
        
        <h4 className="text-xs font-semibold uppercase tracking-wider mb-4" style={{ color: '#9CA3AF' }}>
          Capabilities
        </h4>
        
        <ul className="space-y-3">
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 0 0-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#E8EDDF' }}>Establishes secure connection to Sleeve Hub</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 0 0-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#E8EDDF' }}>Manages access to ECUs, data loggers, and diagnostic tools</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 0 0-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#E8EDDF' }}>Orchestrates containerized edge applications</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 0 0-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#E8EDDF' }}>Streams telemetry and logs to cloud storage</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 0 0-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#E8EDDF' }}>Operates in degraded connectivity scenarios</span>
          </li>
        </ul>
      </div>
      
      {/* Cloud Platform - Sleeve Hub */}
      <div 
        className="rounded-xl p-6 md:p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div 
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-xs font-semibold uppercase tracking-wider mb-4"
          style={{ backgroundColor: 'rgba(79, 179, 184, 0.15)', border: '1px solid rgba(79, 179, 184, 0.4)', color: '#4FB3B8' }}
        >
          Cloud Platform
        </div>
        
        <h3 className="text-2xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
          Sleeve Hub
        </h3>
        
        <p className="text-sm leading-relaxed mb-6" style={{ color: '#9CA3AF' }}>
          Central cloud platform providing web-based dashboard, user access control, and fleet-level orchestration.
        </p>
        
        <h4 className="text-xs font-semibold uppercase tracking-wider mb-4" style={{ color: '#9CA3AF' }}>
          Capabilities
        </h4>
        
        <ul className="space-y-3">
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 0 0-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#E8EDDF' }}>Web-based fleet management dashboard</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 0 0-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#E8EDDF' }}>User authentication and role-based access control</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 0 0-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#E8EDDF' }}>Session orchestration and routing to vehicles</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 0 0-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#E8EDDF' }}>Real-time fleet monitoring and analytics</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 0 0-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#E8EDDF' }}>Centralized log storage and retrieval</span>
          </li>
        </ul>
      </div>
      
    </div>
    
    {/* Architecture Diagram */}
    <div 
      className="rounded-xl p-6 md:p-8"
      style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
    >
      <div className="flex flex-col items-center">
        
        {/* Remote Engineer Box */}
        <div 
          className="rounded-lg px-6 py-3 flex items-center gap-3 mb-6"
          style={{ backgroundColor: '#4FB3B8' }}
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#242423" strokeWidth="2">
            <circle cx="12" cy="8" r="4" />
            <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
          </svg>
          <div>
            <div className="text-xs font-bold" style={{ color: '#242423' }}>REMOTE ENGINEER</div>
            <div className="text-xs" style={{ color: '#242423', opacity: 0.7 }}>Web Interface</div>
          </div>
        </div>
        
        {/* Sleeve Platform Box */}
        <div 
          className="w-full max-w-3xl rounded-lg p-6 mb-6"
          style={{ backgroundColor: '#242423', border: '1px solid #3A3A38' }}
        >
          {/* Header */}
          <div className="flex items-center justify-center gap-2 mb-2">
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
            </svg>
            <span className="text-xs font-bold" style={{ color: '#E8EDDF' }}>SLEEVE PLATFORM</span>
          </div>
          <p className="text-xs text-center mb-6" style={{ color: '#9CA3AF' }}>Cloud Orchestration & Management</p>
          
          {/* Four Feature Boxes */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div 
              className="rounded-lg p-4 text-center"
              style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="1.5">
                <circle cx="12" cy="12" r="3" />
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82-.33l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
              </svg>
              <span className="text-xs" style={{ color: '#9CA3AF' }}>Config</span>
            </div>
            
            <div 
              className="rounded-lg p-4 text-center"
              style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="1.5">
                <rect x="3" y="3" width="18" height="6" rx="1" />
                <rect x="3" y="12" width="18" height="6" rx="1" />
              </svg>
              <span className="text-xs" style={{ color: '#9CA3AF' }}>Data</span>
            </div>
            
            <div 
              className="rounded-lg p-4 text-center"
              style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="1.5">
                <rect x="5" y="4" width="14" height="10" rx="2" />
                <line x1="12" y1="14" x2="12" y2="17" />
                <line x1="8" y1="17" x2="16" y2="17" />
              </svg>
              <span className="text-xs" style={{ color: '#9CA3AF' }}>Auth</span>
            </div>
            
            <div 
              className="rounded-lg p-4 text-center"
              style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="1.5">
                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
                <polyline points="17 6 23 6 23 12" />
              </svg>
              <span className="text-xs" style={{ color: '#9CA3AF' }}>Monitor</span>
            </div>
          </div>
        </div>
        
        {/* Connection Lines */}
        <div className="flex flex-col items-center mb-4">
          <div className="w-0.5 h-4" style={{ backgroundColor: '#9CA3AF' }}></div>
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2">
            <path d="M12 5v14M5 12l7 7 7-7"/>
          </svg>
        </div>
        
        {/* Vehicle Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full max-w-2xl mb-6">
          
          {/* Vehicle 1 */}
          <div 
            className="rounded-lg p-4"
            style={{ backgroundColor: '#242423', border: '1px solid #4FB3B8' }}
          >
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
                  <path d="M5 17h14M6 9h12l-1-4H7L6 9zM6 9v8h12V9" />
                </svg>
                <span className="text-xs font-bold" style={{ color: '#4FB3B8' }}>VEHICLE 1</span>
              </div>
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
                <path d="M5 12.55a11 11 0 0 1 14.08 0M1.42 9a16 16 0 0 1 21.16 0M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01" />
              </svg>
            </div>
            <div className="text-xs mb-3" style={{ color: '#9CA3AF' }}>Munich</div>
            <div className="space-y-1">
              <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></span>
                <span className="text-xs" style={{ color: '#9CA3AF' }}>ECU</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></span>
                <span className="text-xs" style={{ color: '#9CA3AF' }}>Logger</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></span>
                <span className="text-xs" style={{ color: '#9CA3AF' }}>Diag</span>
              </div>
            </div>
          </div>
          
          {/* Vehicle 2 */}
          <div 
            className="rounded-lg p-4"
            style={{ backgroundColor: '#242423', border: '1px solid #4FB3B8' }}
          >
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
                  <path d="M5 17h14M6 9h12l-1-4H7L6 9zM6 9v8h12V9" />
                </svg>
                <span className="text-xs font-bold" style={{ color: '#4FB3B8' }}>VEHICLE 2</span>
              </div>
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
                <path d="M5 12.55a11 11 0 0 1 14.08 0M1.42 9a16 16 0 0 1 21.16 0M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01" />
              </svg>
            </div>
            <div className="text-xs mb-3" style={{ color: '#9CA3AF' }}>Stuttgart</div>
            <div className="space-y-1">
              <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></span>
                <span className="text-xs" style={{ color: '#9CA3AF' }}>ECU</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></span>
                <span className="text-xs" style={{ color: '#9CA3AF' }}>Logger</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></span>
                <span className="text-xs" style={{ color: '#9CA3AF' }}>Diag</span>
              </div>
            </div>
          </div>
          
        </div>
        
        {/* Seamless Remote Access Badge */}
        <div 
          className="rounded-full px-5 py-2 flex items-center gap-2"
          style={{ backgroundColor: '#F5CB5C' }}
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#242423" strokeWidth="2">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
          </svg>
          <span className="text-xs font-semibold" style={{ color: '#242423' }}>Seamless Remote Access</span>
        </div>
        
      </div>
    </div>
    
  </div>
</section>

      {/* Reference Deployment */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    <div 
      className="rounded-xl p-8 md:p-12"
      style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
        
        {/* Left Column - Icon and Label */}
        <div className="lg:col-span-3 flex flex-col items-center lg:items-start">
          <div 
            className="w-20 h-20 rounded-2xl flex items-center justify-center mb-4"
            style={{ backgroundColor: 'rgba(79, 179, 184, 0.2)' }}
          >
            <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
            </svg>
          </div>
          <h2 className="text-sm font-bold uppercase tracking-wider text-center lg:text-left" style={{ color: '#4FB3B8' }}>
            Reference Deployment
          </h2>
        </div>
        
        {/* Right Column - Content */}
        <div className="lg:col-span-9">
          <h3 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
            Volkswagen CARIAD
          </h3>
          
          <p className="text-base leading-relaxed mb-8" style={{ color: '#9CA3AF' }}>
            CARIAD deployed Sleeve to enable remote access to test vehicles across European development sites. The platform provides development teams with on-demand access to in-vehicle hardware, reduces engineer travel, and accelerates SDV iteration cycles.
          </p>
          
          {/* Three Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div>
              <div className="text-lg font-bold mb-1" style={{ color: '#4FB3B8' }}>Remote Access</div>
              <div className="text-sm" style={{ color: '#9CA3AF' }}>Global engineering teams</div>
            </div>
            
            <div>
              <div className="text-lg font-bold mb-1" style={{ color: '#F5CB5C' }}>Efficiency Gains</div>
              <div className="text-sm" style={{ color: '#9CA3AF' }}>Faster development cycles</div>
            </div>
            
            <div>
              <div className="text-lg font-bold mb-1" style={{ color: '#4FB3B8' }}>Edge-to-Cloud</div>
              <div className="text-sm" style={{ color: '#9CA3AF' }}>Reliable data flow</div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
    
  </div>
</section>

      {/* Custom & In-House Tool Integration */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    <div 
      className="rounded-xl p-8 md:p-12"
      style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
        
        {/* Left Column - Icon and Label */}
        <div className="lg:col-span-3 flex flex-col items-center lg:items-start">
          <div 
            className="w-20 h-20 rounded-2xl flex items-center justify-center mb-4"
            style={{ backgroundColor: 'rgba(79, 179, 184, 0.2)' }}
          >
            <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
            </svg>
          </div>
          <h2 className="text-sm font-bold uppercase tracking-wider text-center lg:text-left" style={{ color: '#4FB3B8' }}>
            Custom Integration
          </h2>
        </div>
        
        {/* Right Column - Content */}
        <div className="lg:col-span-9">
          <h3 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
            Custom & In-House Tool Integration
          </h3>
          
          <p className="text-base leading-relaxed mb-8" style={{ color: '#9CA3AF' }}>
            Sleeve supports proprietary and in-house automotive tooling. Engineers can build integrations using our API documentation, or the Sleeve team can deliver integrations on request.
          </p>
          
          {/* Three Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div>
              <div className="text-lg font-bold mb-1" style={{ color: '#4FB3B8' }}>API Access</div>
              <div className="text-sm" style={{ color: '#9CA3AF' }}>Full documentation provided</div>
            </div>
            
            <div>
              <div className="text-lg font-bold mb-1" style={{ color: '#F5CB5C' }}>Custom Builds</div>
              <div className="text-sm" style={{ color: '#9CA3AF' }}>Integrations on request</div>
            </div>
            
            <div>
              <div className="text-lg font-bold mb-1" style={{ color: '#4FB3B8' }}>Proprietary Tools</div>
              <div className="text-sm" style={{ color: '#9CA3AF' }}>In-house tooling support</div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
    
  </div>
</section>

      {/* Final CTA */}
      <section className="py-24 md:py-32 px-4 md:px-6 lg:px-8 border-b border-border">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl font-bold text-foreground mb-6">
            Request Your Personalized Demo
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <div className="flex flex-col items-center">
              <p className="text-sm font-medium text-foreground">Faster iteration</p>
            </div>
            
            <div className="flex flex-col items-center">
              <p className="text-sm font-medium text-foreground">Lower operational cost</p>
            </div>
            
            <div className="flex flex-col items-center">
              <p className="text-sm font-medium text-foreground">Full fleet utilization</p>
            </div>
          </div>
          
          <div className="flex flex-wrap gap-4 justify-center">
            <Link 
              to="/contact" 
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors"
            >
              Request Your Demo
              <Icon name="ArrowRight" size={16} />
            </Link>
            <Link 
              to="/use-cases" 
              className="inline-flex items-center gap-2 px-6 py-3 bg-card border border-border text-foreground rounded-lg font-medium hover:bg-card/80 transition-colors"
            >
              Explore Other Use Cases
              <Icon name="ArrowRight" size={16} />
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AutomotiveFleetManagementUseCaseDetail;